



























































































































































































































































































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: {
    ...mapState('Auth', {
      activeBusiness: 'activeBusiness',
    }),
    ...mapState('Country', {
      countries: 'countries',
    }),
    ...mapState('BusinessCreditLevel', {
      businessCreditLevels: 'businessCreditLevels',
    }),
  },
})
export default class BusinessCreditCheckList extends Vue {
  @Prop() readonly businessOid!: string;
  @Prop({ default: false }) readonly isApproved!: boolean;

  isMounted = false;

  isLoading = false;

  reload = 0;
  // Data
  options = { page: 1, itemsPerPage: 10, query: '' };

  showApprove = {};
  showReject = {};

  countries!: [
    {
      id: number;
      name: string;
      states: {
        id: number;
        name: string;
      }[];
    }
  ];

  businessCreditLevels!: [
    {
      object_id: string;
      currency: string;
      level: string;
      amount_limit: string;
    }
  ];

  isApiFetch = {
    isApiFetchCountiesFinished: false,
    isApiFetchBusinessCreditLevelsFinished: false,
  };

  mounted() {
    this.$store
      .dispatch('Country/fetchList', {
        params: {
          expand: ['states'],
        },
      })
      .then(() => {
        this.isApiFetch['isApiFetchCountiesFinished'] = true;
      });

    if (!this.businessCreditLevels.length) {
      this.$store.dispatch('BusinessCreditLevel/fetchList').then(() => {
        this.isApiFetch['isApiFetchBusinessCreditLevelsFinished'] = true;
      });
    } else {
      this.isApiFetch['isApiFetchBusinessCreditLevelsFinished'] = true;
    }
  }

  @Watch('isApiFetch', { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true;
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false;
        }
      }
      if (isFinished) {
        this.isMounted = true;
      }
    }
  }

  // Methods
  handleFetch(query, page, itemsPerPage) {
    return this.$store.dispatch('BusinessCreditCheck/fetchList', {
      params: {
        expand: [
          'business',
          'business.billing_contact',
          'business.billing_address',
          'business_credit_level',
        ],
        page: page,
        per_page: itemsPerPage,
        is_approved: this.isApproved === true ? 1 : 0,
        business_oid: this.businessOid,
      },
    });
  }

  action(item, actionLocal) {
    this.isLoading = item.object_id;
    // console.debug(item)
    const action =
      actionLocal == 'approve'
        ? 'BusinessCreditCheck/approve'
        : 'BusinessCreditCheck/reject';
    this.$store.dispatch(action, { item }).then(() => {
      this.isLoading = false;
      this.showApprove[item.object_id] = false;
      this.showReject[item.object_id] = false;
      this.reload++;
    });
  }

  editBusiness(oid) {
    this.$router.push({
      name: 'administrator-business-update',
      params: {
        businessOid: oid,
      },
    });
  }

  showAproveAction(oid) {
    this.showApprove[oid] = !this.showApprove[oid];
  }

  showRejectAction(oid) {
    this.showReject[oid] = !this.showReject[oid];
  }

  toAddress(v) {
    let address = v.address1;
    if (v.address2) {
      address += ', ' + v.address2;
    }
    if (v.city) {
      address += ', ' + v.city;
    }
    if (v.postcode) {
      address += ', ' + v.postcode;
    }
    if (v.state_id && v.country_id) {
      const country = this.countries.find(
        (country) => country.id == v.country_id
      );
      const state = country?.states.find((state) => state.id == v.state_id);
      if (country && state) {
        address += ', ' + state.name + ', ' + country.name;
      }
    }
    return address;
  }

  report(oid) {
    this.isLoading = oid;
    this.$store.dispatch('BusinessCreditCheck/report', oid).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'Quescreen - Business Credit Check Application - ' + oid;
      link.click();
      // URL.revokeObjectURL(link.href)
      this.isLoading = false;
      // this.$vs.loading.close('#download-pdf > .con-vs-loading')
    });
  }

  filterLevelsByCurrency(currency) {
    return this.businessCreditLevels.filter(
      (level) => level.currency == currency
    );
  }
}
